import { render, staticRenderFns } from "./Deviceconfigs.vue?vue&type=template&id=44ee60f4&"
import script from "./Deviceconfigs.vue?vue&type=script&lang=js&"
export * from "./Deviceconfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports